interface VStackProps extends React.HTMLProps<HTMLDivElement> {}

export const VStack = ({ className = '', ...props }: VStackProps) => {
  return <div className={`flex flex-col ${className}`} {...props} />
}

export const VSpaceBetweenStack = ({
  className = '',
  ...props
}: VStackProps) => {
  return <VStack className={`justify-between ${className}`} {...props} />
}
